import { RegisterModule } from '@/typings/common'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import {
  LKProfileState,
  LKProfileGetters,
  LKProfileMutations,
  LKProfileActions,
} from './store'
import { MODULE_NAME } from '../utils'

const storeModule = (
  new Module({
    namespaced: true,
    state: LKProfileState,
    getters: LKProfileGetters,
    mutations: LKProfileMutations,
    actions: LKProfileActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as LKProfileStoreModule,
  mapper as LKProfileMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
